<!-- 生日有礼 -->
<template>
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <img
        class="pointer"
        @click="returnBack()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStepNum != 0 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStepNum == 0">
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px; padding-top: 5px">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                @click="handleNav(item, index)"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == tabActive }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid rgba(123, 97, 255, 0.15)"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: rgba(123, 97, 255, 0.05)"
                ></div>
              </div>
              <!-- hover -->
              <div
                class="temImg_content_bgshadow"
                style="height: 432px; border-radius: 8px"
                @click="handleOpen()"
              >
                <div class="temImg_content_bgshadow_codeDZ">
                  <img
                    style="width: 100%"
                    src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div
              class="temImg"
              v-for="(item, index) in giftList"
              :key="item.id"
            >
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    class="imgs"
                    style="width: 100%"
                    :src="item.imageUrl"
                    alt=""
                  />
                  <img
                    v-if="item.days"
                    class="temImg_content_img_free"
                    src="@/assets/thdImg/common/free.svg"
                    alt=""
                    srcset=""
                  />
                  <div v-if="item.days" class="temImg_content_img_time">
                    倒计时：{{ item.days }}
                  </div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="queryId"
                  ref="queryId"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="nextStepKai(item, item.id,index + 1)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 1">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="140px"
        >
          <div class="newsInfo">基本信息</div>
          <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              :disabled="activityData.isStart || backgroundOpacity"
              maxlength="15"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 400px"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动参与对象:" prop="partner">
            <el-checkbox-group
              v-model="ruleForm.partner"
              @change="checkListchange"
              :disabled="activityData.isStart || backgroundOpacity"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                v-for="item in levelList"
                :key="item.value"
                :label="item.value"
                name="partner"
                :disabled="ruleForm.partner.includes('-1')"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>

            <!-- 1.14迭代 生日有礼 -->
            <div style="display:flex">
              <span>入会时间：</span>
              <el-checkbox v-model="ruleDto.isCheckOpenCardTime" :disabled="activityData.isStart || backgroundOpacity">指定时间段</el-checkbox>
              <div class="my_select_time" style="margin-left:8px">
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardStartTime" type="datetime"
                  placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px" class="time1"  :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||activityData.isStart || backgroundOpacity">
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardEndTime" type="datetime"
                  placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px" class="time2"
                  :picker-options="openCardEndTimeOptionsValue" :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||activityData.isStart || backgroundOpacity">
                </el-date-picker>
                <i v-if="!activityData.isStart && !backgroundOpacity" class="el-icon-circle-close date_icon1" @click="clearNewTime"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
            </div>
            <span style="color:red">注意：该条件对【非会员】身份不生效</span>

          </el-form-item>

          <!-- 1.14迭代 plus会员限制 -->
          <el-form-item label="Plus会员身份:" required>
            <el-radio v-model="ruleDto.plusObject" :label="0" :disabled="activityData.isStart || backgroundOpacity">不限</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="1" :disabled="activityData.isStart || backgroundOpacity">Plus会员</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="2" :disabled="activityData.isStart || backgroundOpacity">非plus会员</el-radio>
            <div style="color:red">注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。</div>
          </el-form-item>

          <el-form-item label="活动条件:">
            <el-checkbox
              label="关注店铺后方可参与活动"
              v-model="ruleForm.condFollow"
              :disabled="activityData.isStart || backgroundOpacity"
            ></el-checkbox>
          </el-form-item>
          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="activityStartTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="activityData.isStart || backgroundOpacity"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="activityEndTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                @focus="orderFocus"
                :picker-options="pickerOptionsValueEnd"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="backgroundOpacity"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!activityData.isStart && !backgroundOpacity"
                @click="clearTime()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #7b61ff">{{ timeDay }}</span> 天
              <span style="color: #7b61ff">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动有效期不可超过订购有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
            <div class="act-tip" v-if="isShowTip">
              *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
            </div>
          </el-form-item>
          <el-form-item label="领奖有效期:" required>
            <el-select size="small" v-model="ruleForm.timeType" :disabled="activityData.isStart || backgroundOpacity">
              <el-option
                v-for="item in brithdayList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户生日信息获取:" required>
            <el-radio-group v-model="ruleDto.birthdayInfoType" :disabled="activityData.isStart || backgroundOpacity">
              <el-radio :label="1">用户填写</el-radio>
              <el-radio :label="2">
                <span>自动获取</span>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="获取用户入会时所填的生日信息，如无生日信息依旧需用户进行手动填写生日信息。"
                  placement="bottom"
                >
                  <el-button type="text" style="width: 35px">
                    <i class="el-icon-question" style="color: #ccc;"></i>
                  </el-button>
                </el-tooltip>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="newsInfo">奖品设置</div>
          <el-form-item label="领奖模式:" required>
            <el-radio-group v-model="ruleDto.activityMode" :disabled="activityData.isStart">
              <el-radio :label="0" :disabled="ruleDto.activityMode==1">登记领奖模式</el-radio>
              <el-radio :label="1" :disabled="ruleDto.activityMode==0">
                <span>许愿抽奖模式</span>
                <el-popover placement="right" width="600" trigger="hover">
                  <el-image
                    style="width: 100%"
                    :src="'https://cdn-image.yucrm.cn/images/jd-front-platform/images/mode-wish.png'"
                    :preview-src-list="['https://cdn-image.yucrm.cn/images/jd-front-platform/images/mode-wish.png']"
                  >
                  </el-image>
                  <span slot="reference">
                    <el-button type="text" class="ml12">领奖模式说明</el-button>
                  </span>
                </el-popover>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="ruleDto.activityMode==0">
            <el-form-item required>
              <span slot="label" class="set">奖品设置:</span>
              <div class="setting-tip">
                <div>
                  <span
                    >1、活动期内，生日会员有机会获得礼品，每个自然年只能领取一次。如果在本自然年领取过生日礼包的会员则无法在其他生日礼包活动领取礼包</span
                  >
                </div>
                <div>
                  <span
                    >2、奖品展示图片建议尺寸：300*300像素，图片大小不能超过300K，类型：JPG、PNG</span
                  >
                </div>
                <div class="setting-tip-last-wrap">
                  <span
                    >3、设置多个奖品时，生日会员可同时领取多个奖品，当设置不同份数奖品时，实际领取情况说明：<br /><span
                      class="setting-tip-red"
                      >例：设置积分发放份数为100份，京豆发放份数为20份。则活动开始后前20名领取的会员可同时收到两份奖品，之后参与的80人只能收到积分奖品</span
                    ></span
                  >
                </div>
              </div>
              <div class="setting-radio">
                <el-radio v-model="ruleForm.settingType" :label="1" :disabled="activityData.isStart || backgroundOpacity"
                  >按等级设置</el-radio
                >
                <el-radio v-model="ruleForm.settingType" :label="2" :disabled="activityData.isStart || backgroundOpacity"
                  >统一设置</el-radio
                >
              </div>
              <div v-if="ruleForm.settingType == 1">
                <div class="setting-level">
                  <div
                    :class="[
                      'setting-level-item',
                      { 'setting-level-item__active': levelIndex == index },
                    ]"
                    v-for="(item, index) in getChooseLevel"
                    :key="index"
                    @click="levelClick(index)"
                  >
                    <span>{{ item.name }}</span>
                  </div>
                </div>
                <template v-for="(item, index) in prizeSettingListLevel">
                  <div :key="index">
                    <el-table
                      v-if="levelIndex == index"
                      :data="item.settingList"
                      style="width: 1000px; border: 1px solid #f0f0f0;overflow: visible"
                      :header-cell-style="{
                        background: '#fafafa',
                        'text-align': 'center',
                      }"
                      :cell-style="{ 'text-align': 'center', 'overflow': 'visible'}"
                    >
                      <el-table-column prop="date" label="序号" width="110">
                        <template slot-scope="scope">
                          <span>{{ scope.$index + 1 }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="奖品类型">
                        <template slot-scope="scope">
                          <div v-if="backgroundOpacity || activityData.isStart">
                            <span
                              style="color: #909399;"
                              v-if="scope.row.prizeType == 3"
                              >{{ scope.row.title }}</span
                            >
                            <span
                              style="color:#909399"
                              v-else-if="scope.row.prizeType"
                              >{{ scope.row.prizeType | prizeType }}</span
                            >
                            <span
                              v-else
                              style="color:#909399"
                              >选择奖品</span
                            >
                          </div>
                          <div v-else>
                            <span
                              class="s"
                              @click="centerVis(scope.row)"
                              v-if="scope.row.prizeType"
                            >
                              <span v-if="scope.row.prizeType == 3">
                                {{scope.row.title}}
                              </span>
                              <span v-else>{{ scope.row.prizeType | prizeType }}</span>
                            </span>
                            <span
                              class="s"
                              @click="centerVis(scope.row)"
                              v-else
                            >
                              选奖品
                            </span>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column label="值" width="80" prop="price">
                      </el-table-column>

                      <el-table-column label="奖品总份数" width="180">
                        <template slot-scope="scope">
                          <el-input
                            v-model.number="scope.row.totalAmount"
                            @input.native="
                              (e) =>
                                (scope.row.totalAmount = checkputn(
                                  e,
                                  scope.row,
                                  'jindou'
                                ))
                            "
                            placeholder="请输入..."
                            @input="
                              (scope.row.totalAmount = getNumberData(
                                1,
                                $event,
                                0,
                                1
                              )),
                                prizeNum(scope.row)
                            "
                            @blur="beAdd(scope.row)"
                            :disabled="backgroundOpacity || activityData.isStart"
                          ></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="每日发放限额" width="120">
                        <template slot-scope="scope">
                          <dailyLimitConfig
                            :row="scope.row"
                            :backgroundOpacity="backgroundOpacity"
                            :limitBtnDisabled="backgroundOpacity"
                          ></dailyLimitConfig>
                        </template>
                      </el-table-column>
                      <el-table-column label="奖品展示图片" width="170">
                        <template slot-scope="scope">
                          <el-image class="elImg" :src="scope.row.logo" fit="contain" style="width:40px;height: 40px;background: #D9D9D9;border-radius: 4px 4px 4px 4px;">
                            <div slot="error" class="image-slot">
                            </div>
                          </el-image>
                        </template>
                      </el-table-column>

                      <el-table-column label="操作" :width="220">
                        <template slot-scope="scope">
                          <div v-if="backgroundOpacity || activityData.isStart " class="btn-wrap">
                            <div style="color: #909399;margin-right: 10px;" >上传图片</div>
                            <div style="color: #909399;" v-if="scope.row.prizeType != 3 ">重置</div>
                            <el-button type="text" v-if="activityData.isStart && scope.row.title"
                            @click="itemAddNum('',scope.$index)">增加奖品数量</el-button>
                          </div>
                          <div class="btn-wrap" v-else>
                            <el-upload
                              :disabled="activityData.isStart"
                              class="upload"
                              action="/jd-hd-web/image/upload"
                              :show-file-list="false"
                              :before-upload="beforeUpload2"
                              :on-success="
                                (file) => {
                                  return handleUpload2(file, scope);
                                }
                              "
                            >
                              <div class="s" style="margin-right: 10px">
                                上传图片
                              </div>
                            </el-upload>
                            <span
                              v-if="scope.row.prizeType != 3"
                              class="s"
                              style="margin-right: 10px"
                              @click="cleanData(scope.row)"
                              >重置</span
                            >
                          </div>
                          <div class="del_box" v-if="!activityData.isStart && !backgroundOpacity">
                            <div class="delQx" @click="deleteSetting(scope.$index, item)">
                              <img src="@/assets/images/btn_del.svg" alt="" />
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div
                      v-if="levelIndex == index && !activityData.isStart  && !backgroundOpacity"
                      @click="addSetting(item)"
                      class="add_btn1"
                      style="width: 125px"
                    >
                      添加奖项（{{ item.settingList.length }}/4）
                    </div>
                  </div>
                </template>
              </div>
              <div v-else>
                <el-table
                  :data="prizeSettingList"
                  style="width: 1000px; border: 1px solid #f0f0f0;overflow: visible"
                  :header-cell-style="{
                    background: '#fafafa',
                    'text-align': 'center',
                  }"
                  :cell-style="{ 'text-align': 'center','overflow': 'visible' }"
                >
                  <el-table-column prop="date" label="序号" width="110">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="奖品类型">
                    <template slot-scope="scope">
                      <div v-if="backgroundOpacity || activityData.isStart">
                        <span
                          style="color: #909399;"
                          v-if="scope.row.prizeType == 3"
                          >{{ scope.row.title }}</span
                        >
                        <span
                          style="color:#909399"
                          v-else-if="scope.row.prizeType"
                          >{{ scope.row.prizeType | prizeType }}</span
                        >
                        <span
                          v-else
                          style="color:#909399"
                          >选择奖品</span
                        >
                      </div>
                      <div v-else>
                        <span
                          class="s"
                          @click="centerVis(scope.row)"
                          v-if="scope.row.prizeType"
                        >
                          <span v-if="scope.row.prizeType == 3">
                            {{scope.row.title}}
                          </span>
                          <span v-else>{{ scope.row.prizeType | prizeType }}</span>
                        </span>
                        <span
                          class="s"
                          @click="centerVis(scope.row)"
                          v-else
                        >
                          选奖品
                        </span>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column label="值" width="80" prop="price">
                  </el-table-column>

                  <el-table-column label="奖品总份数" width="180">
                    <template slot-scope="scope">
                      <el-input
                        v-model.number="scope.row.totalAmount"
                        @input.native="
                          (e) =>
                            (scope.row.totalAmount = checkputn(
                              e,
                              scope.row,
                              'jindou'
                            ))
                        "
                        placeholder="请输入..."
                        @input="
                          (scope.row.totalAmount = getNumberData(
                            1,
                            $event,
                            0,
                            1
                          )),
                            prizeNum(scope.row)
                        "
                        @blur="beAdd(scope.row)"
                        :disabled="backgroundOpacity || activityData.isStart"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="每日发放限额" width="120">
                    <template slot-scope="scope">
                      <dailyLimitConfig
                        :row="scope.row"
                        :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"
                      ></dailyLimitConfig>
                    </template>
                  </el-table-column>
                  <el-table-column label="奖品展示图片" width="170">
                    <template slot-scope="scope">
                      <el-image class="elImg" :src="scope.row.logo" fit="contain" style="width:40px;height: 40px;background: #D9D9D9;border-radius: 4px 4px 4px 4px;">
                        <div slot="error" class="image-slot">
                        </div>
                      </el-image>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" :width="220">
                    <template slot-scope="scope">
                      <div v-if="backgroundOpacity || activityData.isStart " class="btn-wrap">
                        <div style="color: #909399;margin-right: 10px;" >上传图片</div>
                        <div style="color: #909399;" v-if="scope.row.prizeType != 3 ">重置</div>
                        <el-button type="text" v-if="activityData.isStart && scope.row.title"
                          @click="itemAddNum('prizeSettingList',scope.$index)">增加奖品数量</el-button>
                      </div>
                      <div class="btn-wrap" v-else>
                        <el-upload
                          :disabled="activityData.isStart"
                          class="upload"
                          action="/jd-hd-web/image/upload"
                          :show-file-list="false"
                          :before-upload="beforeUpload2"
                          :on-success="
                            (file) => {
                              return handleUpload2(file, scope);
                            }
                          "
                        >
                          <div class="s" style="margin-right: 10px">上传图片</div>
                        </el-upload>
                        <span
                          v-if="scope.row.prizeType != 3"
                          class="s"
                          style="margin-right: 10px"
                          @click="cleanData(scope.row)"
                          >重置</span
                        >
                        <div class="del_box" v-if="!activityData.isStart && !backgroundOpacity">
                          <div class="delQx" @click="deleteSetting(scope.$index)">
                            <img src="@/assets/images/btn_del.svg" alt="" />
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div @click="addSettingAll" class="add_btn1" style="width: 125px" v-if="!activityData.isStart && !backgroundOpacity">
                  添加奖项（{{ prizeSettingList.length }}/4）
                </div>
              </div>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item label="许愿赠送收集次数:" required>
              <el-input
              class="input-style"
                v-model="ruleDto.collectNum"
                placeholder="请输入"
                @input="ruleDto.collectNum = getNumberData(
                    1,
                    $event,
                    0,
                    1,
                    999999
                  )"
              ></el-input>
              <span class="text-style">次收集机会</span>
              <span class="tip-color">*用户完成许愿后，将获得对应次数的心愿礼品收集机会，可用于收集心愿礼品并放入生日奖池参与抽奖</span>
            </el-form-item>
            <el-form-item label="心愿收集任务:" required>
              <taskComponent
                :taskList.sync="taskDataList"
                mainText="收集"
                :extraText="extraText"
                :activityData="activityData"
                :activityStartTime="activityStartTime"
                :activityEndTime="activityEndTime"
              />
            </el-form-item>
            <el-form-item label="生日心愿礼品设置:" required>
              <lotteryPrize
                isShowDailyLimit
                :prizeSettingList.sync="giftSettingList"
                :activityData="activityData"
                :valueRow="valueRow"
                :backgroundOpacity="backgroundOpacity"
                :isDisabled="activityData.isStart"
                :isShowIndex="true"
                :isShowLottery="false"
                :isShowAddBtn="true"
                :isShowMoveBtn="true"
                :isCustomizeTip="true"
                :isShowDeleteBtn="true"
                @addPrizeSetting="addGiftSettingList"
              >
              <template #tipText>
                <div>
                  生日礼包默认开启100%中奖逻辑，相关规则要求如下：
                </div>
                <div>
                  1. 奖项数量：需配置5-20个奖项（最少5个，最多20个）；
                </div>
                <div>
                  2. 概率配置：<span class="red-text">每个奖品中奖概率不可为0%，</span> 因用户完成收集任务后可自主选品放入生日奖池，系统无法提前预判奖池构成；
                </div>
                <div>
                  3. 奖池库存及概率调整：用户奖池中若部分奖品库存为空，<span class="red-text">系统将自动等比放大其余有库存奖品的中奖概率，总概率保持100%，保障100%中奖；若奖池中所有奖品库存均为空，用户抽奖时将提示：所有奖品已经被抢光啦！</span>
                </div>
              </template>
              </lotteryPrize>
            </el-form-item>
            <el-form-item label="是否开启兜底奖品设置:" label-width="1" required>
              <el-radio-group
                v-model="ruleDto.isOpenPocket"
                :disabled="activityData.isStart"
              >
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">不开启</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="兜底奖品设置:" required v-if="ruleDto.isOpenPocket==1">
              <span class="red-text">开启后，用户满足抽取生日奖池条件，但奖池全部奖品暂无剩余库存后，会分配兜底奖品，若兜底奖品库存也为空，系统则会提示奖品已抢光。</span>
              <newPrizeTable
                :prizeList.sync="prizeList"
                :isDisabled="activityData.isStart"
                :tableInfo="tableInfo"
                :valueRow="valueRow"
                :isShowUpLoadBtn="true"
                :isShowReset="true"
              >
              <template #titleHeader>
                <span style="color: red">*</span>奖品名称（12字内）
              </template>
              <template #dailyLimitNum="{row}">
                <dailyLimitConfig
                  :row="row"
                  :backgroundOpacity="backgroundOpacity"
                  :limitBtnDisabled="backgroundOpacity"
                ></dailyLimitConfig>
              </template>
              </newPrizeTable>
            </el-form-item>
            <div class="newsInfo">配置项设置</div>
            <el-form-item label="生日许愿标题:" required>
              <div class="setting-box">
               <div class="flex-spc-x">
                  <span class="tip-color">此处为预置生日心愿，用户许愿时可从以下文案中选择 1 条作为心愿，也可自定义愿望。</span>
                  <el-popover placement="right" width="270" trigger="hover">
                    <el-image
                      style="width: 100%"
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/signal-wish.png"
                      :preview-src-list="[
                        'https://cdn-image.yucrm.cn/images/jd-front-platform/images/signal-wish.png',
                      ]"
                    />
                    <el-button slot="reference" style="width: auto;padding: 0 !important;" type="text">小程序端示意图</el-button>
                  </el-popover>
               </div>
                <el-table
                :data="wishSetting"
                style="width: 100%; border: 1px solid #f0f0f0;overflow: visible"
                :header-cell-style="{
                  background: '#fafafa',
                  'text-align': 'left',
                }"
                :cell-style="{ 'text-align': 'left', overflow: 'visible' }"
                >
                <el-table-column
                  label="序号"
                  width="90"
                  type="index"
                ></el-table-column>
                <el-table-column label="心愿名称">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.wishName"
                      placeholder="请输入"
                      maxlength="12"
                      show-word-limit
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="心愿名称">
                  <template slot-scope="scope">
                    <el-button type="text" style="width: auto;padding: 0 !important;" v-if="scope.$index != 0" @click="upWishSetting(scope.$index)">上移</el-button>
                    <el-button type="text" style="width: auto;padding: 0 !important;" v-if="scope.$index != wishSetting.length - 1" @click="downWishSetting(scope.$index)">下移</el-button>
                    <el-button type="text" style="width: auto;padding: 0 !important;" v-if="wishSetting.length > 3" @click="deleteWishSetting(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
                </el-table>
                <div class="mt12">
                  <el-button type="primary" style="width: auto;" @click="addWishSetting">添加心愿（{{wishSetting.length}}/30）</el-button>
                  <el-button type="text" style="width: auto;padding: 0 !important;" @click="resetWishSetting">重置</el-button>
                </div>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="祝福文案设置:" :required="isShowWin">
            <div style="width: 570px">
              <el-input
                :disabled="backgroundOpacity"
                maxlength="200"
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.blessingText"
              ></el-input>
            </div>
          </el-form-item>
          <orderShopInfo v-model="customerPaperwork"/>
          <div class="newsInfo">曝光商品</div>
          <el-form-item label="曝光商品:" class="zindexBox">
            <el-checkbox
              v-model="ruleForm.exposureSwitch"
              @change="exposureSwitchChange"
              :disabled="backgroundOpacity"
            >
              是否添加曝光商品
            </el-checkbox>
            <el-button
              style="width: 155px; margin: 0 15px; display: inline-block"
              :class="{ add_btn1: ruleForm.exposureSwitch }"
              @click="exposureProducts"
              :disabled="
                ruleForm.exposureSwitch == false
              "
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </el-button>
            <el-radio-group
              v-model="ruleForm.radio"
              :disabled="
                ruleForm.exposureSwitch == false || backgroundOpacity
              "
            >
              <el-radio :label="0">显示京东价</el-radio>
              <!-- <el-radio :label="1">显示促销价</el-radio> -->
            </el-radio-group>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px;
              "
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                  :class="backgroundOpacity ? 'unmover' : ''"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible" v-if="!backgroundOpacity">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <div class="newsInfo">分享设置</div>
          <el-form-item label="小程序分享标题:" required label-width="125">
            <el-input
              type="text"
              style="width: 400px"
              show-word-limit
              v-model="ruleForm.shareTitle"
              :maxlength="28"
              @input="inp"
              :disabled="activityData.isStart || backgroundOpacity"
            ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享简介:" required>
            <el-input
              type="text"
              style="width: 400px"
              show-word-limit
              v-model="ruleForm.shareIntroduce"
              :maxlength="28"
              @input="inp"
              :disabled="activityData.isStart || backgroundOpacity"
            ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享图片:" required>
            <div class="miniAppPic">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload1"
                  :on-success="handleUpload1"
                  :disabled="activityData.isStart || backgroundOpacity"
                >
                  <el-button
                    size="mideal"
                    class="returnBtn"
                    :disabled="activityData.isStart || backgroundOpacity"
                    >自定义上传</el-button
                  >
                </el-upload>
                <span
                  v-if="!activityData.isStart && !backgroundOpacity"
                  class="reset"
                  @click="picUrlReset1"
                  >重置</span
                >
                <span v-else class="reset" style="cursor: default">重置</span>
              </div>
              <div class="bottom">
                <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：200px * 200px</p>
                  <p>图片大小：1MB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <div class="newsInfo">活动规则</div>
          <el-form-item label="规则内容:" required>
            <div style="width: 570px;
              backgroundcolor: rgba(250, 250, 250, 1);
              position: relative;">
              <el-input
                maxlength="2000"
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.ruleDescription"
                :disabled="backgroundOpacity"
              ></el-input>
              <div class="prosi" style="color: #909399">
                  （{{
                    ruleForm.ruleDescription.length
                      ? ruleForm.ruleDescription.length - 1
                      : 0
                  }}/2000）
              </div>

              <div>
                <el-button
                  :disabled="backgroundOpacity"
                  type="primary"
                  class="generate"
                  plain
                  @click="generateRule"
                  >生成规则</el-button
                >
                <span class="desc">
                  <img
                    src="@/assets/images/new_icon_reminder.png"
                    style="
                      display: inline-block;
                      float: left;
                      position: absolute;
                      width: 14px;
                      height: 14px;
                      color: #ffffff;
                      margin: 17px 4px 0px -13px;
                    "
                  />
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </span>
              </div>
            </div>
          </el-form-item>
          <actInfoSetting :valueRow="valueRow" :activityData="activityData" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum != 0">
      <el-button
        v-show="!itemId"
        class="returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <el-button class="returnBtn createBtn" @click="saveDraft" v-if="hasDraftBtn">存为草稿</el-button>
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          class="keepBtn"
          v-if="isSave"
          type="primary"
          size="medium"
          @click="resetForm"
          v-preventReClick
          >保存并完成设置</el-button
        >
      </template>

      <el-button
        v-show="itemId"
        class="returnBtn"
        size="medium"
        @click="cancelEdit"
        >取消</el-button
      >
      <el-button v-show="itemId" class="keepBtn" type="primary" size="medium"
        >保存并完成设置</el-button
      >
    </div>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      :isSupportVirtualGroup="true"
    ></selectGoodsMonitor>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="isSelectProduct"
      :echoDate="echoDate"
      :actId="valueRow"
      :num="1"
      :JingdouCount="JingdouCount"
      @choose-shop="getTheData"
      @close="productClose"
    >
    </selectProduct>

    <!-- 增加奖品弹窗 -->
    <addPrizeNum :isShowAddNum="isShowAddNum" :prizeData="toAddItem" @confirm="confirmAdd" @close="isShowAddNum=false"/>

    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dailyLimitConfig from "@/components/dailyLimitConfig.vue";
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
import {
  createBirthDayGift,
  updateBirthDayGift,
  getBirthDayDetail,
  hdTaskTemplateGroup,
  sellerImage,
} from "@/api/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import { updateCommon } from "@/api/integralCenter/integralTask";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";

import { uploadpic } from "@/api/paradiseAndTaskCommonController.js";
import addPrizeNum from "./components/add-prize-num.vue";
import taskComponent from "./components/taskComponent.vue";
import lotteryPrize from "./components/lotteryPrize/index.vue";
import newPrizeTable from "./components/newPrizeTable/index.vue";
import {
  conditionValue,
  getTaskTypeOptions,
} from "./components/taskCommonField/index.js";
import { getTaobaoItemListSku } from "@/api/analysis/ware-controller";
const shareIcon = "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/common/birthDay.png"
const  giftSettingData = [
  {
    index: 0,
    prizeType: null,
    price: null,
    title: "",
    totalAmount: null,
    percentage: null,
    logo: "",
    prizeObjectType: 0
  },
  {
    index: 1,
    prizeType: null,
    price: null,
    title: "",
    totalAmount: null,
    percentage: null,
    logo: "",
    prizeObjectType: 0
  },
  {
    index: 2,
    prizeType: null,
    price: null,
    title: "",
    totalAmount: null,
    percentage: null,
    logo: "",
    prizeObjectType: 0
  },
  {
    index: 3,
    prizeType: null,
    price: null,
    title: "",
    totalAmount: null,
    percentage: null,
    logo: "",
    prizeObjectType: 0
  },
  {
    index: 4,
    prizeType: null,
    price: null,
    title: "",
    totalAmount: null,
    percentage: null,
    logo: "",
    prizeObjectType: 0
  },
];
const prizeDatas = [
  {
    assetsId: null, // 资产项id(计划id优惠卷id商品id)
    prizeType: null,
    price: null,
    logo: null,
    title: "",
    totalAmount: null,
    singleAmount: "",
    prizeObjectType: 1,
  },
];
export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
    addPrizeNum,
    taskComponent,
    lotteryPrize,
    newPrizeTable,
    dailyLimitConfig
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    ids: {
      type: String,
      default: "",
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  computed:{
    // 获取选中的会员
    getChooseLevel(){
      if(this.ruleForm.partner.includes("-1")){
        return this.levelList
      }else{
        return this.levelList.filter(item=>this.ruleForm.partner.includes(item.value))
      }
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    taskTypeOptions() {
      return getTaskTypeOptions("收集");
    },
    isShowWin() {
      return this.ruleDto.activityMode == 1
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    }
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(3);
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品卡";
      }else if (num == "12") {
        result = "专享价";
      }else if (num == "13") {
        result = "令牌";
      } else if (num == "14") {
        result = "实物（随单发）";
      }
      return result;
    },
  },
  data() {
    return {
      isKeyActivity: 0,
      placementPosition: [],
      customerPaperwork: {},
      wishSetting: [
        {
          wishName: "平安喜乐，万事顺遂",
          sort: 0,
        },
        {
          wishName: "愿所有美好，都如期而至",
          sort: 1,
        },
        {
          wishName: "岁岁常欢愉，年年皆胜意",
          sort: 2,
        },
        {
          wishName: "所求皆如愿，所行化坦途",
          sort: 3,
        },
        {
          wishName: "多喜乐，长安宁，岁岁无忧",
          sort: 4,
        },
        {
          wishName: "愿日子清透，万事皆甜",
          sort: 5,
        },
        {
          wishName: "新岁启封，喜乐常伴",
          sort: 6,
        },
        {
          wishName: "岁岁常安康，年年皆欢喜",
          sort: 7,
        },
      ],
      conditionValue: conditionValue,
      tableInfo: [
        {
          label: "奖品类型",
          prop: "prizeType",
          isPrize: true,
          minWidth: 100,
        },
        {
          label: "值",
          prop: "price",
          minWidth: 100,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          isPrize: true,
          slotHead: "titleHeader",
          minWidth: 200,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          isPrize: true,
          minWidth: 120,
        },
        {
          label: "每日发放限额",
          slot: "dailyLimitNum",
          minWidth: 120,
        },
        {
          label: "图片",
          prop: "logo",
          isPrize: true,
          minWidth: 120,
        },
        {
          label: "操作",
          minWidth: "90px",
          prop: "operation",
          isPrize: true,
          minWidth: 142,
        },
      ],
      prizeList: prizeDatas,
      giftSettingList: giftSettingData,
      extraText: "*用户完成对应任务，可获得心愿礼品收集次数；收集的心愿礼品可放入生日奖池参与抽奖",
      taskDataList: [],
      actEndTime: "",
      isShowTip: false,
      // 1.14迭代
      ruleDto:{
        isCheckOpenCardTime:false,
        openCardStartTime:'',
        openCardEndTime:'',
        plusObject:0, //plus会员
        birthdayInfoType: 1, //用户生日信息获取
        activityMode: 0,//领奖模式
        collectNum: "",//收集次数
        isOpenPocket: 1, //是否开启兜底奖品设置
      },
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleDto.openCardEndTime).valueOf() - 24 * 60 * 60 * 1000;
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf();
        },
      },

      isSelectProduct: false,
      mainImagelist: [],
      templateId: "",
      tabActive: 0,
      navItem: {},
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      selectGoodsArr: [],
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=12`,
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      valueRow: null,
      echoDate: {},
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          if(this.ruleForm.endTime){
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.endTime).valueOf()
          }else{
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if(this.ruleForm.startTime){
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.startTime).valueOf()
          }else{
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      winningRate: 0,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        term: [{ required: true, message: "请填写抽奖条件", trigger: "blur" }],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        ruleDescription: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
      },
      ruleForm: {
        exposureSwitch: false,
        radio: 0,
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        timeType: 'day',
        settingType: 2,
        blessingText: "",
      },
      sharePic: "",
      activityStartTime: null,
      activityEndTime: null,
      prizeSettingList: [
        {
          prizeType: null,
          price: null,
          totalAmount: null,
          percentage: null,
        },
      ],
      prizeSettingListLevel: [],
      index: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      disableTime: false,

      templateJson: {
        templateUItype: "",
      },

      levelList: [],
      levelIndex: 0,
      brithdayList: [
        {
          label: "生日当天",
          value: 'day',
        },
        {
          label: "生日当周",
          value: 'week',
        },
        {
          label: "生日当月",
          value: 'month',
        },
      ],
      uploadSize:false,
      levelData:[], // 会员数据
      priceImg:'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/prizeShow.png',//默认产品图
      itemArr: [],
      isDraft:false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: '',
      toAddIndex: 0,
    };
  },
  async created() {
    console.log("当前玩法id", this.activityData.id);
    this.sharePic = shareIcon;
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
    await this.getLevel();
    this.hdTaskTemplateGroup();
  },
  methods: {
    upWishSetting(index) {
      this.wishSetting[index] = this.wishSetting.splice(
        index - 1,
        1,
        this.wishSetting[index]
      )[0];
    },
    downWishSetting(index) {
      this.wishSetting[index] = this.wishSetting.splice(
        index + 1,
        1,
        this.wishSetting[index]
      )[0];
    },
    addWishSetting() {
      if(this.wishSetting.length >= 30) {
        this.$message.error("心愿最多添加30个");
        return
      }
      this.wishSetting.push({ 
        wishName: "",
        sort: this.wishSetting.length,
      })
    },
    resetWishSetting() {
      // let wishTextList = {
      //   0: "平安喜乐，万事顺遂",
      //   1: "愿所有美好，都如期而至",
      //   2: "岁岁常欢愉，年年皆胜意",
      //   3: "所求皆如愿，所行化坦途",
      //   4: "多喜乐，长安宁，岁岁无忧",
      //   5: "愿日子清透，万事皆甜",
      //   6: "新岁启封，喜乐常伴",
      //   7: "岁岁常安康，年年皆欢喜"
      // }
      this.wishSetting = [
        {
          wishName: "平安喜乐，万事顺遂",
          sort: 0,
        },
        {
          wishName: "愿所有美好，都如期而至",
          sort: 1,
        },
        {
          wishName: "岁岁常欢愉，年年皆胜意",
          sort: 2,
        },
        {
          wishName: "所求皆如愿，所行化坦途",
          sort: 3,
        },
        {
          wishName: "多喜乐，长安宁，岁岁无忧",
          sort: 4,
        },
        {
          wishName: "愿日子清透，万事皆甜",
          sort: 5,
        },
        {
          wishName: "新岁启封，喜乐常伴",
          sort: 6,
        },
        {
          wishName: "岁岁常安康，年年皆欢喜",
          sort: 7,
        }
      ]
    },
    addGiftSettingList() {
      this.giftSettingList.push({
        index: this.giftSettingList.length,
        prizeType: null,
        price: null,
        title: "",
        totalAmount: null,
        percentage: null,
        logo: "",
        prizeObjectType: 0,
      })
    },
    // 点击下单时间显示提示
    orderFocus() {
      if(this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let {toAddBelong, toAddIndex} = this;
      if(toAddBelong == 'prizeSettingList'){
        this[toAddBelong][toAddIndex].totalAmount = num;
      }else {
        this.prizeSettingListLevel[this.levelIndex].settingList[index].totalAmount = num;
      }
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr,index) {
      if(arrStr == 'prizeSettingList'){
        this.toAddItem = {
          ...this[arrStr][index],
          num: this[arrStr][index].totalAmount
        };
      }else {
        this.toAddItem = {
          ...this.prizeSettingListLevel[this.levelIndex].settingList[index],
          num: this.prizeSettingListLevel[this.levelIndex].settingList[index].totalAmount
        };
      }
      if( !this.toAddItem.title ) {
        this.$message.error("没有奖品不能设置数量！")
        return
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },

    inp(val) {
      this.$forceUpdate();
    },
    // 京东计划数量计算
    prizeNum(row) {
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error(
              "礼品卡总份额数量不能大于该礼品卡剩余预算额！"
            );
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    //上传图片前校验  分享图片
    beforeUpload1(file) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 200;
        let height = 200;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function() {
            let valid = width === this.width  && height === this.height;
            valid ? resolve() : reject(this);
            _this.uploadSize = valid;
        }
        img.src = _URL.createObjectURL(file);
      }).then(()=>{
        return file
      },()=>{
        this.$message.info("图片宽高不符合要求,请重新上传");
        return Promise.reject()
      })
      // 校验尺寸和类型
      const isLt1M = file.size < 1024 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isType = sorts.includes(type)
      if (!isLt1M) {
        this.$message.info("上传图片大小不能超过 1MB");
      }
      if (!isType) {
        this.$message.info("所选文件格式不符，请重新选择");
      }
      return isLt1M && isType && isSize
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        console.log(this.uploadSize);
        if (this.uploadSize) {
          this.ruleForm.sharePic = res.data;
          this.$forceUpdate();
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      this.ruleForm.sharePic = this.sharePic;
      this.$forceUpdate();
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true;
        item.title = item.groupName;
      });
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
      // console.log(this.selectGoodsArr, 4444444);
    },

    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },

    selectGoodsClose(data) {
      console.log(data, 222);
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        console.log(this.mainImagelist);
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },

    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$forceUpdate();
    },

    nextStepKai(row, templateId = 0,index=1) {
      this.localStepNum = 1;
      this.templateJson.templateUItype = index;
      if (templateId) {
        this.templateId = templateId;
        if(row) {
          this.ruleDto.activityMode = +row.layout - 1;
          if(this.ruleDto.activityMode == 1) {
            this.ruleForm.blessingText = "生日快乐!愿往后岁岁年年,平安喜乐常相伴,日子温柔又闪光,所求皆如愿！"
          } else {
            this.ruleForm.blessingText = ""
          }
        }
      }
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push({
              name:item.customerLevelName,
              value:String(item.customerLevel)
            });
          });
          this.prizeSettingListLevel = res.data.map((item) => {
            return {
              customerLevel:String(item.customerLevel),
              name: item.customerLevelName,
              settingList: [
                {
                  prizeType: null,
                  price: null,
                  totalAmount: null,
                  percentage: null,
                },
              ],
            };
          });
          // 获取详情
          this.getDetail(); 
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      // 重置选中状态
      this.levelIndex = 0
      // 全部
      let levelArr = []
      if(val.includes("-1")){
        this.ruleForm.partner = ["-1"];
        levelArr = this.levelList
      }else{
        levelArr = this.levelList.filter(item=>val.includes(item.value))
      }
      this.prizeSettingListLevel = levelArr.map(level=>{
        const index = this.prizeSettingListLevel.findIndex(item=>item.customerLevel == level.value)
        console.log(index)
        // 已存在
        if(index != -1){
          return this.prizeSettingListLevel[index]
        }else{
          return {
            customerLevel:level.value,
            name: level.name,
            settingList: [
              {
                prizeType: null,
                price: null,
                totalAmount: null,
                percentage: null,
              },
            ],
          };
        }
      })
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg="
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text:url + this.giftList[index].imageUrl,
        });
      }
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (
          row.quantityTotal &&
          row.price &&
          row.totalAmount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...row,
            prizeCount: row.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.fileList = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    // changeImg(row) {
    //   console.log(row, 33333333333);
    // },
    httpRequest() {},
    //生成规则
    generateRule() {
      let text1 = "",
        text2 = "",
        text3 = "注意：以上奖品为商家发放的全部心愿礼品，仅为用户可收集奖品范围，不代表用户必然获得其中任意一款；最终能否获得奖品，以生日奖池抽奖结果为准。",
        text4 = "",
        text5 = "",
        text6 = `\n2.生日礼领取规则：\n（1) 领取条件：符合活动对象身份要求，在领奖有效期内进入活动页按提示操作即可领取生日礼遇；
（2) 每月生日礼数量有限，发完即止，具体数量以当月页面显示为准。
（3) 生日信息提交后一般情况下次月生效；生日信息填写完成后不可修改，请谨慎填写。
（4) 每位会员1年仅可领取1次生日礼遇；`,
        text7 = "\n2.许愿抽奖玩法介绍：\n（1）参与许愿：用户在完成生日填写后，可在活动页引导下许下自己的生日愿望。许愿的方式分为两种:(1)直接填写心愿，心愿输入在12字符以内。需注意，您输入的内容不得违反法律法规行政规章的规定、社会主义核心价值观、公序良俗等;(2)选择预设的心愿，您可以通过“换一换”功能挑选更符合您心意的心愿。\n（2）心愿礼品收集:许愿完成后，用户可以通过点击页面上的“收集”按钮，消耗自己的心愿收集机会，每点击一次按钮，即可选择一次心愿礼品。用户可以通过点击“调整奖池”，将当前心愿礼品放入自己的生日抽奖池中。需注意，部分心愿礼品需要先完成对应的心愿收集任务，才能将其放入生日抽奖池。点击商品图上的“收集TA”继续完成任务。只有已经收集成功的心愿礼品，才能放入生日许愿池中。为免疑义，心愿礼品收集玩法说明中所称“收集的心愿礼品”，并不意味着用户已实际获得该礼品，而是获得将该礼品放入生日抽奖池的机会。最终能否获得该奖品，以生日奖池抽奖结果展示为准。\n" +
        "（3）生日抽奖：完成生日许愿后，当用户点击页面中的“立即抽生日礼物”，即可进行生日抽奖。“生日专属好礼”指通过京东生日礼许愿玩法，收集并抽奖赢取的心愿礼品，具体抽取的京东生日礼，以用户中奖界面实际展示为准。当用户点击生日抽奖按钮后，会展示二次确认弹窗，确认用户即将抽奖的许愿池礼品内容。请注意，一旦点击“确认抽奖”，将无法再退回页面进行新的心愿礼品收集或者编辑奖池。抽奖后，未放入许愿池的心愿礼品、以及未抽中的心愿礼品将无法再次查看。",
        actObj = "",
        precautions = "1.客户信息收集：页面弹屏提示中奖客户提供收货地址、号码和奖项；(请及时填写，方便奖品发放);实物奖品采取寄送方式发放，获得中奖资格的用户根据填写的姓名、联系电话、详细地址信息发放。如因用户原因无法联系上，即奖品作废不再补发，或如用户未填写真实有效的信息或填写收货信息不详，均视为放弃奖品;\n2.活动参与主体资格：\n（1）同一用户仅限参与活动一次。同一用户是指账户、手机号码、收件地址、支付账号、身份证号码、设备标识符、注册信息、网络操作日志、交易订单信息等与用户身份和行为相关的信息，其中任意一项或数项存在相同、相似，亦或通过特定标记批量信息进行分析，其数项存在相同、相似的（包括但不限于批量相同、雷同、邻近、虚构的地址）均视为同一用户。同一用户注册、持有、使用或控制多个会员账号，商家有权取消/限制其参与本活动或领取奖品的资格；\n" + 
      "（2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其获奖资格;\n3.注意事项：\n（1）活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其获奖资格（如奖品已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利;\n（2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动\n（3）本活动所发放的实物奖、虚拟奖品均不得提现、不得转赠他人、不得为他人付款;\n（4）是否获得中奖资格以活动发布者后台统计结果为准;\n（5）实物奖品一经发出，无质量问题恕不退换，如有疑问，请咨询客服。\n"+ 
      "（6）商家可根据活动的实际进行情况，在法律允许的范围内，对本活动规则进行调整或变动，相关调整或变动将公布在活动规则页上。\n（7）如对本活动有任何疑问，请咨询客服。\n";
        let firstTextStr = "一、【活动时间与对象】\n";
        let secondTextStr = "\n二、【如何获奖】";
        let thirdTextStr = "\n\n三、【活动奖品】\n";
        let fourthTextStr = `\n\n四、【注意事项】\n${ precautions }`
        // 活动对象
        let levelText = [];
        if (this.ruleForm.partner.length > 0) {
          // 全部
          if(this.ruleForm.partner.includes('-1')){
            levelText.push("不限");
          }else{
            levelText = this.levelList.filter(item=>this.ruleForm.partner.includes(item.value)).map(item=>item.name)
          }
          // text3 = "活动参与对象：" + levelText.splice(",");
        }
        let membership = "";
        membership = `仅限指定${this.ruleDto.openCardStartTime}-${this.ruleDto.openCardEndTime}时间范围入会的会员参与`
        let plusText = ''
        // 1.14迭代 plus会员
        if(this.ruleDto.plusObject!=0){
          plusText =  `Plus会员身份：${this.ruleDto.plusObject==1?'Plus会员':'非Plus会员'}`;
        }else{
          plusText =  `Plus会员身份：不限`;
        }
        if(this.ruleForm.partner.includes("-1")&&!this.ruleDto.isCheckOpenCardTime&&this.ruleDto.plusObject==0) {
          actObj = "2.活动对象：不限\n";
        } else {
        let obj1 = "会员等级：" + levelText.join("、");
          let obj2 = "首次入会时间：" + membership;
          let arr = [obj1,obj2,plusText]
          actObj = "2.活动对象：仅限指定身份可参与\n";
          arr.forEach((item,index)=>{
            actObj += `（${index+1}）${item}\n`
          })
        }
              // 活动条件
      if (this.ruleForm.condFollow) {
        text1 += "3.活动条件：关注店铺后方可参加活动";
      }
      //活动时间
      if (this.ruleForm.startTime && this.ruleForm.endTime) {
        text2 =
          "1.活动时间：" + this.ruleForm.startTime + "-" + this.ruleForm.endTime;
      }

      // 领奖有效期
      if (this.ruleForm.timeType) {
        const obj = this.brithdayList.find(item=>item.value == this.ruleForm.timeType)
        text4 = `\n1.领奖有效期：${obj.label}可领取奖励，过期视作放弃领取；`;
      }
      if(this.ruleDto.activityMode == 0){
        secondTextStr += text4 + text6;
      }else{
        secondTextStr += text4 + text7;
      }
      if(this.ruleDto.activityMode == 0) {
        // 奖品设置
        if (this.ruleForm.settingType == 1) {
          let listArrStr = "";
          const circleNums = ["①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩"];
          if (this.getChooseLevel && this.getChooseLevel.length) {
            this.getChooseLevel.forEach((levelItem, index) => {
              const item = this.prizeSettingListLevel.find(p => p.customerLevel == levelItem.value);
              if (item && item.settingList && item.settingList.length) {
                const hasValidPrizes = item.settingList.some(list => list.title);
                if (hasValidPrizes) {
                  let num = circleNums[index] ? circleNums[index] : (index + 1) + ".";
                  listArrStr += `\n${num}${levelItem.name}：`;
                  item.settingList.forEach((list, idx) => {
                    if (list.title) {
                      if(list.prizeType == 3){
                        listArrStr += `\n（${idx + 1}）奖品${idx + 1}：${list.title}，共 ${list.totalAmount} 份，单份奖品价值 ${list.price} 元；`;
                      }else {
                        listArrStr += `\n（${idx + 1}）奖品${idx + 1}：${list.title}，共 ${list.totalAmount} 份；`;
                      }
                    }
                  });
                }
              }
            });
          }
          if (listArrStr) {
            text5 = listArrStr;
          }
          thirdTextStr += "\n1.活动奖品：按当前会员等级，选其一奖品领取" + text5;
        } else {
          let listArrStr = "";
          if (this.prizeSettingList && this.prizeSettingList.length) {
            this.prizeSettingList.filter(item => item.title).forEach((list, index) => {
              if(list.prizeType == 3){
                listArrStr += `\n（${index + 1}）奖品${index + 1}：${list.title}，共 ${list.totalAmount} 份，单份奖品价值${list.price}元；`;
              }else {
                listArrStr += `\n（${index + 1}）奖品${index + 1}：${list.title}，共 ${list.totalAmount} 份；`;
              }
            });
          }
          if (listArrStr) {
            text5 = listArrStr;
          }
          thirdTextStr += text5;
        }
      } else {
        this.giftSettingList.forEach((item, index) => {
          text5+="生日礼奖品:\n"
          text5 += `（${index+1}）奖品${index+1}：${item.title}，共${item.totalAmount}份${item.prizeType==3 ? ('，单份奖品价值'+item.price+'元') : ''}；`
          if(index<this.giftSettingList.length-1) {
            text5 += `\n`
          }
        })
        thirdTextStr += text5 + "\n" +text3;
      }
      firstTextStr+= text2 + "\n" + actObj + text1;
      this.ruleForm.ruleDescription = firstTextStr + secondTextStr + thirdTextStr + fourthTextStr;
    },
    //清除
    cleanData(row) {
      if(this.activityData.isStart  || this.backgroundOpacity)return;
      row.assetsId = null;
      row.prizeType = null;
      row.price = null;
      row.title = null;
      row.logo = null;
      row.percentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
    },
    //选择奖品弹窗
    centerVis(row) {
      if(row.prizeType&&row.prizeType == 14){
        this.$message({
          message: "该奖品类型不支持修改",
          type: "warning",
        });
        return
      }
      this.JingdouCount.prizeCount = row.totalAmount;
      this.echoDate = row;
      this.isSelectProduct = true
      this.$nextTick(()=>{
        this.$refs.selectProduct.openDialog();
      })
    },
    // 关闭奖品弹窗
    productClose(){
      this.isSelectProduct = false
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      // this.$emit("returnBack");
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      if (prizeType == 1) {
        this.echoDate.couponType = data.couponType;
      }
      if (data.giftType) {
        this.echoDate.giftType = Number(data.giftType);
      }
      this.echoDate.price = Number(data.discount);
      this.echoDate.assetsId = Number(data.couponId);
      this.$set(this.echoDate, "logo", data.logo?data.logo:this.priceImg);
      this.echoDate.prizeType = prizeType;
      if (prizeType == 4) {
        this.echoDate.title = data.discount + "店铺积分";
      } else {
        this.echoDate.title = data.name;
      }
      if (data.singleAmount) {
        this.echoDate.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.echoDate.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if(!data.isGoodManage) {
          this.echoDate.skuId = data.skuId;
          delete this.echoDate.isGoodManage
        } else {
          this.echoDate.isGoodManage = data.isGoodManage;
        }
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.echoDate.budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.echoDate.budgetRemain = data.budgetRemain;
      }
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      // 活动参与对象
      if (this.ruleForm.partner.length == 0) {
        this.$message.warning("请选择活动参与对象");
        return;
      }

      // 1.14迭代 这里判断
      if(this.ruleDto.isCheckOpenCardTime&&(!this.ruleDto.openCardStartTime||!this.ruleDto.openCardEndTime)){
        return this.$message.warning("请选择入会时间");
      }


    if(this.ruleDto.activityMode==0) {
      // 请将奖品填写完整！
      let isFlay = false;
      // 统一设置
      if(this.ruleForm.settingType == 2){
        if(this.prizeSettingList.length == 0){
          isFlay = true;
        }
        this.prizeSettingList.forEach((item) => {
          if (item.prizeType != 9) {
            if (!item.totalAmount || !item.title) {
              isFlay = true;
            }
          }
        });
      }else{
        // 按等级
        this.prizeSettingListLevel.forEach((item) => {
          if(item.settingList.length == 0){
            isFlay = true;
          }
          item.settingList.forEach(list=>{
            if (list.prizeType != 9) {
              if (!list.totalAmount || !list.title) {
                isFlay = true;
              }
            }
          })
        });
      }
      if (isFlay) {
        return this.$message.warning("请将奖品填写完整！");
      }
    } else {
      if(!this.ruleDto.collectNum) {
        return this.$message.warning("请输入许愿赠送收集次数");
      } 
      if(this.taskDataList.length == 0) {
        return this.$message.warning("请添加心愿收集任务");
      }
      if(this.giftSettingList.length>0) {
        let isFlag = this.giftSettingList.some((item)=>{
          return !item.title || !item.prizeType || !item.percentage
        })
        if(isFlag) {
          return this.$message.warning("请完善生日心愿礼品设置");
        }
      }

      if(this.ruleDto.isOpenPocket==1) {
        let isFlag2 = this.prizeList.some((item)=>{
          return !item.title || !item.prizeType
        })
        if(isFlag2) {
          return this.$message.warning("请完善兜底奖品设置");
        }
      }
      let isFlag3 = this.wishSetting.some((item)=>{
        return !item.wishName
      })
      if(isFlag3) {
        return this.$message.warning("请完善生日许愿标题");
      }
      if(!this.ruleForm.blessingText) {
        return this.$message.warning("请输入祝福文案");
      }
    }
    if(!this.useValidateMoreActSet(this)) {
      return;
    }
      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    async handleDialogCloseAnoth() {
      let obj = {};
      obj = this.deepClone(this.ruleForm);
      obj.ruleDTO = {
        taskList: [],
      };
      //领奖有效期
      obj.ruleDTO.awardValidity = this.ruleForm.timeType
      //奖品配置
      obj.ruleDTO.awardConfig = this.ruleForm.settingType
      //祝福文案
      if(this.ruleForm.blessingText){  
        obj.ruleDTO.content = this.ruleForm.blessingText
      }
      //关注店铺后方可参与互动
      obj.ruleDTO.requestFollow = this.ruleForm.condFollow
      obj.ruleDTO.openCardFollow = 1;
      // 分享
      obj.ruleDTO.shareTitle = this.ruleForm.shareTitle;
      obj.ruleDTO.shareIntroduce = this.ruleForm.shareIntroduce;
      obj.ruleDTO.sharePic = this.ruleForm.sharePic;
      obj.isKeyActivity = this.isKeyActivity;
      obj.placementPosition = this.placementPosition.join(',');
      
      // 奖品设置
      //进行中修改的名次奖品设置
      let prizes = []
      if(this.ruleDto.activityMode==0) {
        if(this.ruleForm.settingType == 1){
          // 按等级
          obj.pointActivityPrizeDTOList = []
          this.prizeSettingListLevel.forEach(list=>{
            list.settingList.forEach(item=>{
              const itemObj = {
                ...item,
                taskIndex:list.customerLevel,
                title: item.title,
                assetsId: item.assetsId,
                prizeType: item.prizeType,
                logo: item.logo,
                discount: item.price || item.singleAmount,
                singleAmount: item.singleAmount,
                price: item.price,
                totalAmount: item.totalAmount,
              }
              if (item.prizeType == 1) {
                itemObj.quota = item.quota;
                itemObj.couponType = item.couponType;
              }
              if (item.prizeType == 3) {
                if(item.isGoodManage==1) {
                  itemObj.isGoodManage = item.isGoodManage
                }
              }
              obj.pointActivityPrizeDTOList.push(itemObj)
              // 进行中奖品份数数据
              if(this.activityData.isStart){
                prizes.push({
                  ...item,
                  prizeId:item.id,
                  totalAmount: item.totalAmount
                })
              }
            })
          })
        }else{
          obj.pointActivityPrizeDTOList = this.prizeSettingList.map(item=>{
            const obj = {
              ...item,
              title: item.title,
              assetsId: item.assetsId,
              prizeType: item.prizeType,
              logo: item.logo,
              discount: item.price || item.singleAmount,
              singleAmount: item.singleAmount,
              price: item.price,
              totalAmount: item.totalAmount,
            }
            if (item.prizeType == 1) {
              obj.quota = item.quota;
              obj.couponType = item.couponType;
            }
            if (item.prizeType == 3) {
              if(item.isGoodManage==1) {
                obj.isGoodManage = item.isGoodManage
              }
            }
            // 进行中奖品份数数据
            if(this.activityData.isStart){
              prizes.push({
                ...item,
                prizeId:item.id,
                totalAmount: item.totalAmount
              })
            }
            return obj
          })
        }
      } else {
        // 任务设置
        if (this.taskDataList.length) {
          obj.ruleDTO.taskList = this.taskDataList.map((item) => {
            const obj = {
              activityType:
                item.type == 8 ||
                item.type == 12 ||
                item.type == 7 ||
                (item.type == 16 && item.activityType == 2)
                  ? 2
                  : 1,
              taskType: item.type,
              taskValidity: item.taskTime,
            };
            if (item.id) {
              obj.id = item.id;
            }
            // 指定时间
            if (item.taskTime == 2) {
              obj.startTime = item.startTime;
              obj.endTime = item.endTime;
            }
            // 商品
            if (item.skuIds.length) {
              obj.skuIds = item.skuIds.join(",");
            }
            if (item.type == 18) {
              obj.activityType = 2;
              obj.inviteLimit = item.condition;
              obj.taskDoLimit = item.condition2;
            }
            // 浏览会场-跳转链接
            if (item.type == 5) {
              obj.jumpUrl = item.jumpUrl;
            }
            // 好友助力-邀请人数上限
            if (item.type == 8) {
              obj.inviteLimit = item.inviteLimit;
            }
            if (item.type == 17) {
              obj.activityType = 2;
              obj.orderCountType = item.orderCountType;
              obj.orderType = item.orderType;
              obj.skuType = item.skuType;
              obj.itemTotalLimit = item.itemTotalLimit;
              obj.amtLimit = item.amtLimit;
              obj.orderStartTime = item.orderStartTime;
              obj.orderEndTime = item.orderEndTime;

              obj.giveType = item.giveType;
              obj.countType = item.countType;
              obj.taskDoType = item.taskDoType;
              obj.stepList = item.stepList 
              obj.skuIds = []
              obj.venderIds = item.venderIds.join(",");
              obj.sellerSkuList = item.sellerSkuList.map((item)=>{
                  return {
                    skuIds: item.skuIds,
                    venderId: item.venderId,
                  }
                });
              obj.orderPaymentType = item.orderPaymentType;
              obj.mergeOrder = item.mergeOrder;
            }
            if (item.type == 20) {
              obj.activityType = 2;
              obj.skuType = item.skuType;
              obj.orderStartTime = item.orderStartTime;
              obj.orderEndTime = item.orderEndTime;
              obj.countType = item.countType;
              obj.giveType = 1;
              obj.taskDoType = 1;
            }
            // 任务门槛上限
            if (this.conditionValue.includes(item.type)) {
              if (item.type == 12 || item.type == 16) {
                obj.giveLimit = item.condition;
                obj.taskDoLimit = item.condition2;
              } else if (item.type == 4) {
                // 加购商品
                obj.addCartLimit = item.condition;
              } else if (item.type == 17) {
                obj.giveLimit = 1;
                if (
                  item.orderCountType == 0 ||
                  ((item.giveType == 1 || item.giveType == 2) &&
                    item.taskDoType == 1)
                ) {
                  obj.taskDoLimit = item.condition2;
                } else {
                  obj.taskDoLimit = 1;
                }
              } else if (item.type == 20) {
                obj.taskDoLimit = item.condition2;
              } else {
                obj.giveLimit = item.condition;
              }
            }
            if (item.type == 7) {
              obj.giveLimit = item.giveLimit;
            }
            return obj;
          });
        } else {
          obj.ruleDTO.taskList = [];
        }
        let giftSettingLists = this.giftSettingList.map((item)=>{
          return {
            ...item,
            prizeObjectType: 0,
          }
        });
        if(this.ruleDto.isOpenPocket==1) {
          let prizeLists = this.prizeList.map((item)=>{
            return {
              ...item,
              prizeObjectType: 1,
            }
          })
          giftSettingLists = giftSettingLists.concat(prizeLists)
        }
        obj.pointActivityPrizeDTOList = giftSettingLists
        if(this.activityData.isStart){
          giftSettingLists.forEach(item=>{
            let obj = {
              ...item,
              prizeId:item.id,
              totalAmount: item.totalAmount,
              prizeObjectType: item.prizeObjectType,
            }
            if(item.prizeObjectType==1) {
              obj.logo = item.logo
            }
            prizes.push(obj)
          })
        }
        // 生日许愿标题
        obj.ruleDTO.birthWishTitle = this.wishSetting.map((item)=>item.wishName)
      }
      obj.templateJson = this.templateJson; //多个模板
      obj.allowLevel = this.ruleForm.partner.join(","); //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      // 1.14迭代 这里提交
      obj.ruleDTO.isCheckOpenCardTime = this.ruleDto.isCheckOpenCardTime
      obj.ruleDTO.openCardStartTime = this.ruleDto.openCardStartTime
      obj.ruleDTO.openCardEndTime = this.ruleDto.openCardEndTime
      obj.ruleDTO.plusObject = this.ruleDto.plusObject
      obj.ruleDTO.birthdayInfoType = this.ruleDto.birthdayInfoType
      obj.ruleDTO.activityMode = this.ruleDto.activityMode
      obj.ruleDTO.collectNum = this.ruleDto.collectNum
      obj.ruleDTO.isOpenPocket = this.ruleDto.isOpenPocket
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.exposureSwitch ? 1 : 0;
      obj.itemList = this.itemListFor; //曝光商品集合
      obj.templateId = this.templateId;
      if(this.customerPaperwork) {
        obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork)
      }
      // V2.5 => 复制，去除id和旧的模板数据
      if (this.activityData.isCopy) {
        this.ids = "";
        delete obj.templateJson;
      }
      if (this.checked == true || this.isDraft) {
        if (this.ids == "" || this.isDraft || this.isDraftEdit) {
          if(this.isDraft){
            obj.status = 5
            // 草稿箱奖品填写完整校验-若不全则为空
            obj.pointActivityPrizeDTOList = obj.pointActivityPrizeDTOList.filter(item=>item.prizeType)
          }
          // 草稿箱编辑-添加活动id
          if(this.isDraftEdit){
            obj.id = this.valueRow.id
          }
          if(this.activityData.isCopy){
            delete obj.id
          }
          createBirthDayGift(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          delete obj.templateJson;
          let res;
          if (this.activityData.isStart) {
            let params = {
              activityId: this.ids,
              ruleDescription: obj.ruleDescription,
              prizes,
              isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
              itemList: this.itemListFor,
              ruleDTO: obj.ruleDTO,
              templateId: this.templateId,
              taskList: obj.ruleDTO.taskList
            };
            if(this.actEndTime!=this.activityEndTime) {
              params.endTime = this.activityEndTime
            }
            res = await updateCommon(params);
          } else {
            // 修改添加主键id
            obj.pointActivityId = this.ids
            res = await updateBirthDayGift(obj);
          }
          if (res && res.code == 1) {
            this.joinBlackList = false;
            this.$router.push({
              name: "throw",
              query: {
                id: res.data.id,
                activityType: res.data.activityType,
              },
            });
            this.$message.success(res.message);
          } else {
            if (res.message) {
              this.$message.error(res.message);
            } else {
              this.$message.error(res.data.message);
            }
          }
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.ids != "") {
        let id = this.ids;
        this.valueRow = {
          id: id,
        };
        getBirthDayDetail(id)
          .then((res) => {
            // 活动名称
            this.ruleForm.activityName = res.data.activityName + (this.activityData.isCopy?"复制":"");
            // 会员
            this.ruleForm.partner = res.data.allowLevel.split(",");
            this.isKeyActivity = res.data.isKeyActivity||0;
            this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(',') : ["SHOP"];
            // 1.14迭代 这里回显
            this.ruleDto={
              isCheckOpenCardTime:res.data.ruleDto.isCheckOpenCardTime,
              openCardStartTime:res.data.ruleDto.openCardStartTime,
              openCardEndTime:res.data.ruleDto.openCardEndTime,
              plusObject:res.data.ruleDto.plusObject, //plus会员
              birthdayInfoType: res.data.ruleDto.birthdayInfoType || 1, //用户生日信息获取
              activityMode: res.data.ruleDto.activityMode ? res.data.ruleDto.activityMode : 0,//领奖模式
              collectNum: "",//收集次数
              isOpenPocket: 1, //是否开启兜底奖品设置
            }
            if(this.ruleDto.openCardStartTime&&this.ruleDto.openCardEndTime) {
              this.ruleDto.isCheckOpenCardTime = true
            }
            // 关注店铺后方可参与互动
            this.ruleForm.condFollow = res.data.ruleDto.requestFollow
            // 分享
            this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
            this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
            this.ruleForm.sharePic = res.data.ruleDto.sharePic;
            // 领奖有效期
            this.ruleForm.timeType = res.data.ruleDto.awardValidity

            //祝福文案
            if(res.data.ruleDto.content){  
              this.ruleForm.blessingText = res.data.ruleDto.content
            }
            if(res.data.ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(res.data.ruleDto.customerPaperwork)
            }
            if(this.ruleDto.activityMode == 1){
              this.ruleDto.collectNum = res.data.ruleDto.collectNum;
              this.ruleDto.isOpenPocket = res.data.ruleDto.isOpenPocket;
              this.wishSetting = res.data.ruleDto.birthWishTitle.map((item)=>{
                return {
                  wishName: item
                }
              })
              let taskList = res.data.ruleDto.taskList
              // 任务回显
              const goodsPromise = [];
              if (taskList.length > 0) {
                this.taskDataList = taskList.map((item) => {
                  const obj = {
                    id: item.id,
                    type: item.taskType,
                    taskTime: item.taskValidity,
                    condition: null,
                    condition2: null,
                    count: null,
                    endTime: null,
                    startTime: null,
                    skuIds: [],
                    inviteLimit: null,
                    jumpUrl: null,
                    selectGoodsSkuList: [],
                    activityType:
                      item.taskType == 16 ||
                      item.taskType == 17 ||
                      item.taskType == 7
                        ? item.activityType
                        : 1,
                    skuType: 0,
                    orderType: 0,
                    orderCountType: 1,
                    itemTotalLimit: null,
                    amtLimit: null,
                    orderEndTime: null,
                    orderStartTime: null,
                    orderPaymentType: 1,
                    mergeOrder: false,
                  };
                  // 指定时间
                  if (item.taskValidity == 2) {
                    obj.startTime = item.startTime;
                    obj.endTime = item.endTime;
                  }
                  // 商品
                  if (item.skuIds) {
                    obj.skuIds = item.skuIds.split(",");
                    let skuIdsLength = obj.skuIds.length;
                    let skuIds = obj.skuIds.toString();
                    goodsPromise.push(
                      getTaobaoItemListSku({
                        current: 1,
                        size: skuIdsLength,
                        skuIds: skuIds.split(","),
                      })
                    );
                  }
                  // 浏览会场-跳转链接
                  if (item.taskType == 5) {
                    obj.jumpUrl = item.jumpUrl;
                  }
                  // 好友助力-邀请人数上限
                  if (item.taskType == 8) {
                    obj.inviteLimit = item.inviteLimit;
                  }
                  if (item.taskType == 17) {
                    obj.orderCountType = item.orderCountType;
                    obj.orderType = item.orderType;
                    obj.skuType = item.skuType;
                    obj.itemTotalLimit = item.itemTotalLimit;
                    obj.amtLimit = item.amtLimit;
                    obj.orderStartTime = item.orderStartTime;
                    obj.orderEndTime = item.orderEndTime;
                    obj.giveType = item.giveType;
                    obj.countType = item.countType;
                    obj.taskDoType = item.taskDoType;
                    obj.stepList = item.stepList?item.stepList:[]
                    obj.selectGoodsSkuList = item.itemList ? item.itemList : [];
                    const venderIdList = 
                    item.venderIds
                      ? item.venderIds.split(",").map((item) => +item)
                      : [];
                    const list = item.sellerSkuList&&item.sellerSkuList.length?item.sellerSkuList:[{
                      skuIds: item.skuIds ? item.skuIds.split(",") : [],
                      venderId: this.venderId,
                      itemList: [],
                    }];
                    if(this.activityData.isCopy) {
                      obj.venderIds = [this.venderId]
                      obj.sellerSkuList = list.filter((row)=>{
                        if(row.venderId&&row.venderId == this.venderId){
                          return {
                            skuIds: item.skuIds,
                            venderId: this.venderId,
                            itemList: [],
                          }
                        }
                      })
                    } else {
                      obj.venderIds = venderIdList
                      obj.sellerSkuList = list
                    }
                    obj.orderPaymentType = item.orderPaymentType===null ? 1:item.orderPaymentType;
                    obj.mergeOrder = item.mergeOrder||false;
                  }
                  if (item.taskType == 20) {
                    obj.skuType = item.skuType;
                    obj.orderStartTime = item.orderStartTime;
                    obj.orderEndTime = item.orderEndTime;
                    obj.countType = item.countType;
                    this.taskOrderList =
                      item.stepList && item.stepList.length > 0
                        ? item.stepList
                        : [];
                    this.selectGoodsSkuList = item.itemList;
                    this.hasSelectGoods = item.itemList || [];
                    obj.selectGoodsSkuList = item.itemList;
                  }
                  if (item.taskType == 18) {
                    obj.condition = item.inviteLimit;
                    obj.condition2 = item.taskDoLimit;
                  }
                  // 任务门槛上限
                  const taskTypeObj = this.taskTypeOptions.find(
                    (option) => option.value == item.taskType
                  );
                  if(taskTypeObj) {
                    if (this.conditionValue.includes(item.taskType)) {
                      if (item.taskType == 12) {
                        obj.condition = item.giveLimit;
                        obj.condition2 = item.taskDoLimit;
                      } else if (item.taskType == 4) {
                        obj.condition = item.addCartLimit;
                        obj.count = taskTypeObj.taskCount;
                      } else if (item.taskType == 16) {
                        obj.condition = item.giveLimit;
                        obj.condition2 = item.taskDoLimit;
                        obj.activityType = item.activityType;
                      } else if (item.taskType == 17) {
                        obj.activityType = 2;
                        obj.condition = item.giveLimit;
                        obj.condition2 = item.taskDoLimit;
                        obj.count = taskTypeObj.taskCount;
                      } else if (item.taskType == 20) {
                        obj.activityType = 2;
                        obj.condition2 = item.taskDoLimit;
                      } else {
                        obj.condition = item.giveLimit;
                        obj.count = taskTypeObj.taskCount;
                      }
                    } else {
                      obj.condition = taskTypeObj.taskCondition;
                      obj.count = taskTypeObj.taskCount;
                    }
                  }
                  if (item.taskType == 7) {
                    obj.giveLimit = item.giveLimit;
                  }

                  return obj;
                });
                if (goodsPromise.length > 0) {
                  Promise.all(goodsPromise).then((res) => {
                    this.taskDataList
                      .filter((item) => item.skuIds && item.skuIds.length)
                      .forEach((item, index) => {
                        item.selectGoodsSkuList = res[index].data.records;
                      });
                  });
                }
              }
            }
            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              // 规则
              this.ruleForm.ruleDescription = res.data.ruleDescription
              if(this.ruleDto.activityMode == 1){
                //奖品配置
                this.ruleForm.settingType = res.data.ruleDto.awardConfig
                let prizeLists = res.data.pointActivityPrizeDTOList;
                this.giftSettingList = prizeLists.length>0 ? prizeLists.filter((item)=>{
                  return item.prizeObjectType == 0
                }) : giftSettingData;
                let prizeList = prizeLists.length>0 ? prizeLists.filter((item)=>{
                  return item.prizeObjectType == 1
                }) : prizeDatas;
                if(prizeList.length > 0) {
                  this.prizeList = prizeList
                } 
              } else {
                //奖品配置
                this.ruleForm.settingType = res.data.ruleDto.awardConfig
                // 按等级
                if(res.data.pointActivityPrizeDTOList && res.data.pointActivityPrizeDTOList.length){
                  if(res.data.ruleDto.awardConfig == 1){
                    // 全部
                    let levelArr = []
                    if(this.ruleForm.partner.includes("-1")){
                      levelArr = this.levelList
                    }else{
                      levelArr = this.levelList.filter(item=>this.ruleForm.partner.includes(item.value))
                    }
                    this.prizeSettingListLevel = levelArr.map((item) => {
                      const obj = {
                        customerLevel:item.value,
                        name: item.name,
                        settingList: [],
                      }
                      res.data.pointActivityPrizeDTOList.forEach(list=>{
                        if(item.value == list.taskIndex){
                          obj.settingList.push({...list,minNum:item.totalAmount})
                        }
                      })
                      return obj
                    });
                  }else{
                    // 统一设置
                    this.prizeSettingList = res.data.pointActivityPrizeDTOList.map(item=>{
                      item.minNum = item.totalAmount
                      return {
                        ...item
                      }
                    })
                  }
                }
              }
            }
            this.templateJson = JSON.parse(res.data.templateJson);
            this.activityStartTime = res.data.startTime?res.data.startTime:null
            this.activityEndTime = res.data.endTime?res.data.endTime:null
            this.actEndTime = res.data.endTime;
            this.activityTimeChange();
            this.winningRate = this.winningRate.toFixed(3);
            console.log([String(res.data.startTime), String(res.data.endTime)]);
            this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
            this.ruleForm.exposureSwitch =
              res.data.isExposureItem == 0 ? false : true;
            this.selectGoodsArr = res.data.itemList;
            this.mainImagelist = res.data.itemList;
            this.itemListFor = res.data.itemList;
            // v2.5 => 复制不需要回显奖品和规则
            if (this.activityData.isCopy) {
              this.ruleForm.ruleDescription = "";
            }
          })
          .catch((res) => {});
      } else {
        // 新增-默认活动时间
        if(!this.valueRow){
          this.activityStartTime = this.$getDate(30)[0]
          this.activityEndTime = this.$getDate(30)[1]
        }
        this.activityTimeChange();
      }
    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
      this.activityStartTime = null
      this.activityEndTime = null
    },
    // 活动时间改变
    activityTimeChange() {
      this.ruleForm.startTime = this.activityStartTime;
      this.ruleForm.endTime = this.activityEndTime;
      this.$nextTick(() => {
        if(this.ruleForm.endTime && this.ruleForm.startTime){
          let nowTime = new Date().getTime();
          let start = new Date(this.ruleForm.startTime).valueOf();
          let end = new Date(this.ruleForm.endTime).valueOf();
          let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
          let hdInvalidateDate = new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();
          this.timeDay = Math.floor(
            Math.abs(
              new Date(this.ruleForm.endTime) -
                new Date(this.ruleForm.startTime)
            ) /
              1000 /
              60 /
              60 /
              24
          );
          //计算小时
          const date3 = new Date(this.ruleForm.endTime).getTime() - new Date(this.ruleForm.startTime).getTime();
          const leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
          // 查看不需要校验
          if(!this.backgroundOpacity){
            if (start < nowTime) {
              if (this.ids) {
                this.disableTime = true;
              } else {
              }
            }
            if (end < nowTime) {
              this.$message.warning("结束时间不能小于当前时间");
            }
            if (end < start) {
              this.$message.warning("结束时间不能小于开始时间");
              return;
            }
            if (end > invalidateDate) {
              this.$message.warning("活动时间不能超过软件有效期，请重新选择");
              this.activityEndTime = null;
              this.ruleForm.endTime = null;
              return;
            }
            if (end > hdInvalidateDate) {
              this.$message.warning("活动时间不可超过互动数据授权有效期！");
              this.activityEndTime = null;
              this.ruleForm.endTime = null;
              return;
            }
          }
        }
      });
    },
    // 选择礼品
    choosegifts() {},
    // 保留小数点后两位
    oninput2(val) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }

      let winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });

      if (winningRate > 100) {
        val = String(100 - (winningRate - val));
      } else if (winningRate == 100) {
        if (val >= 100) {
          val = "100";
        } else {
          val = String(100 - (winningRate - val));
          if (val == 0) {
            val = "";
          }
        }
      }
      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
    },
    oninput(val) {
      if (val && val <= 0) {
        val = "1";
      }
      return val;
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    levelClick(index) {
      this.levelIndex = index;
    },
    //上传图片前校验  奖品图片设置
    beforeUpload2(file) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 300;
        let height = 300;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function() {
            let valid = width === this.width  && height === this.height;
            valid ? resolve() : reject(this);
            _this.uploadSize = valid;
        }
        img.src = _URL.createObjectURL(file);
      }).then(()=>{
        return file
      },()=>{
        this.$message.info("奖品展示图片尺寸不符合要求,请重新上传");
        return Promise.reject()
      })
      // 校验尺寸和类型
      const isLt3M = file.size < 300 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isType = sorts.includes(type)
      if (!isLt3M) {
        this.$message.info("奖品展示图片大小不符合要求,请重新上传");
      }
      if (!isType) {
        this.$message.info("奖品展示图片格式不符合要求,请重新上传");
      }
      return isLt3M && isType && isSize
    },
    // 上传成功  奖品图片设置
    handleUpload2(res, scope) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        console.log(this.uploadSize)
        console.log(res.data)
        if (this.uploadSize) {
          this.$set(scope.row,'logo',res.data)
        }
      }
    },
    // 添加奖项-会员
    addSetting(item) {
      if (item.settingList.length > 3)
        return this.$message.warning("最多只能设置4个奖品");
      item.settingList.push({
        prizeType: null,
        price: null,
        totalAmount: null,
        percentage: null,
      });
    },
    // 添加奖项
    addSettingAll() {
      if (this.prizeSettingList.length > 3)
        return this.$message.warning("最多只能设置4个奖品");
      this.prizeSettingList.push({
        prizeType: null,
        price: null,
        totalAmount: null,
        percentage: null,
      });
    },
    // 删除
    deleteSetting(index, item) {
      // 会员
      if (item) {
        item.settingList.splice(index, 1);
      } else {
        this.prizeSettingList.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.prosi {
  position: absolute;
  bottom: 37px;
  right: 29px;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  // margin-top: 20px;
  margin: -24px;
  margin-bottom: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #7b61ff;
            border-bottom: 1px solid #7b61ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #7b61ff;
            border-left: 1px solid #7b61ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          width: 206px;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #7b61ff;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #7b61ff;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #7b61ff;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #7b61ff;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #7b61ff;
      color: #7b61ff;
      transition: all 0.2s;
      &:hover {
        background-color: #7b61ff;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #7b61ff;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
    /deep/ .el-table .el-table__header-wrapper th .cell {
      text-align: center;
      font-weight: 500;
    }
    /deep/ .el-table .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
    /deep/ .el-table--enable-row-transition .el-table__body td {
      text-align: center;
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #7b61ff;
        border-bottom: 1px solid #7b61ff;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #7b61ff;
        border-left: 1px solid #7b61ff;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: system-ui;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    display: flex;
    left: 0;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #7b61ff;
      background: rgba(123, 97, 255, 0.1);
      border: 1px solid #7b61ff;
      &:hover {
        color: #fff;
        background: #7b61ff;
      }
    }
    .reset {
      color: #7b61ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
.setting-tip {
  margin: 30px 0px 20px 0px;
  &-red {
    color: red;
  }
  &-last-wrap {
    line-height: normal;
  }
}
.setting-radio {
  margin-bottom: 20px;
}
.setting-level {
  display: flex;
  align-items: center;
  &-item {
    width: 125px;
    text-align: center;
    background-color: #e9effc;
    &__active {
      color: #fff;
      background-color: #7b61ff;
    }
  }
}
.btn-wrap {
  display: flex;
  align-items: center;
}
.add_btn1 {
  cursor: pointer;
  color: #7b61ff;
  border: 1px solid #7b61ff;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.del_box {
  position: absolute;
  left: 200px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.award-text {
  line-height: normal;
}

.input-style {
  width: 90px;
}
.text-style {
  margin-left: 8px;
  color: #666666;
}
.tip-color {
  margin-left: 8px;
  color: #FF8E0C;
}

.red-text {
  color: #ff0000;
}

.setting-box {
  width: 1000px;
}

.setting-box {
  width: 1000px;
}

.mt12 {
  margin-top: 12px;
}

.flex-spc-x {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
<style lang="scss">
.createPlayStep {
  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #7B61FF;
  //   border-color: #7B61FF;
  //   .el-step__line {
  //     background-color: #7B61FF;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #7B61FF;
  //   border-color: #7B61FF;
  // }
  // .el-step__title.is-process {
  //   color: #7B61FF;
  // }
  // .el-step__title.is-success {
  //   color: #7B61FF;
  // }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
</style>
